/**
 * Push the assessment's Skills Intelligence™ evidence into the Skills Engine
 * store at the end of a run, so the living dashboard, the /skills surface and
 * the report all read the same evidence.
 *
 * Best-effort and never blocking: the report can always recompute from the
 * response log, so a failed push costs nothing a learner can see.
 */
import { supabase } from "@/integrations/supabase/client";
import { skillsEvidenceFrom } from "./skillsEvidence";
import type { AssessmentV2State } from "./types";

export async function pushSkillsEvidence(state: AssessmentV2State | null): Promise<boolean> {
  const records = skillsEvidenceFrom(state);
  if (records.length === 0) return false;
  try {
    const { error } = await supabase.functions.invoke("skills-engine-compute", {
      body: { op: "save", records },
    });
    return !error;
  } catch {
    return false;
  }
}
